import React from 'react';
import { createBreakpointMapTextSize, stopPropagationAndCallFunction } from '../../../helpers/react-helpers';
import TriggerTooltip from '../../../trigger-tooltip';
import { FocusedLabel, InfoIconFocusedLabelButton, InputLabelTypography, UnfocusedLabel } from './style';
export default function Label(props) {
  var {
    unfocusedLabel,
    focusedLabel,
    isActive,
    label,
    hasInlineIcon,
    hasInlinePlusMinusIconButtons,
    unfocusedLabelTextSize,
    htmlFor,
    onInfoIconClick,
    enableInfoIconTooltip,
    tooltipContent,
    dangerouslySetOverlayInnerHTML,
    isInfoTooltipOpen
  } = props;
  var textSizeMap = createBreakpointMapTextSize(unfocusedLabelTextSize);
  return /*#__PURE__*/React.createElement(InputLabelTypography, {
    isActive: isActive,
    type: 'body1'
  }, /*#__PURE__*/React.createElement(UnfocusedLabel, {
    htmlFor: htmlFor,
    hasInlineIcon: hasInlineIcon,
    hasInlinePlusMinusIconButtons: hasInlinePlusMinusIconButtons,
    isActive: isActive,
    textSizeMap: textSizeMap
  }, unfocusedLabel || label), /*#__PURE__*/React.createElement(FocusedLabel, {
    htmlFor: htmlFor,
    isActive: isActive,
    textSizeMap: textSizeMap
  }, !enableInfoIconTooltip && /*#__PURE__*/React.createElement(React.Fragment, null, focusedLabel || label, onInfoIconClick && /*#__PURE__*/React.createElement(InfoIconFocusedLabelButton, {
    isActive: isActive,
    onMouseDown: stopPropagationAndCallFunction(onInfoIconClick),
    icon: 'Info',
    size: 16
  })), enableInfoIconTooltip && tooltipContent && /*#__PURE__*/React.createElement(TriggerTooltip, {
    placement: 'topLeft',
    overlay: tooltipContent,
    dangerouslySetOverlayInnerHTML: dangerouslySetOverlayInnerHTML,
    forceVisible: isInfoTooltipOpen && isActive
  }, /*#__PURE__*/React.createElement("span", null, focusedLabel || label, /*#__PURE__*/React.createElement(InfoIconFocusedLabelButton, {
    isActive: isActive,
    onMouseDown: stopPropagationAndCallFunction(() => {}),
    icon: 'Info',
    size: 16
  })))));
}